import { render } from "./EmailAlert.vue?vue&type=template&id=5b2528d5"
import script from "./EmailAlert.vue?vue&type=script&lang=js"
export * from "./EmailAlert.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__